import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_C2C_URL, TRANSACTION_STATUS_POLL_INTERVAL } from "../constants"
import { IGetSbpOutcomeTransferStatusResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function get(
  token: string | null,
  outcomeTransferId: string | undefined,
) {
  const response = await axios(`${API_C2C_URL}/${outcomeTransferId}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка загрузки данных")
  }
  return response.data
}

export const useGetSbpOutcomeTransferStatus = (
  outcomeTransferId: string | undefined,
  enabled: boolean,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IGetSbpOutcomeTransferStatusResponse>({
    queryKey: ["sbp-outcome-transfer-status", outcomeTransferId],
    queryFn: () => get(token, outcomeTransferId),
    refetchInterval: TRANSACTION_STATUS_POLL_INTERVAL,
    enabled,
  })
}
